<div class="admin-search">
  @if (isModal) {
    <ion-toolbar mode="ios" color="light">
      <ion-buttons slot="start" (click)="dismiss()">
        <ion-button>Cancel</ion-button>
      </ion-buttons>
    </ion-toolbar>
  }
  <div class="admin-search-shell">
    <ion-searchbar
      mode="md"
      class="admin-searchbar"
      [value]="grobalSearch ? globalSearchText : searchText"
      [debounce]="500"
      (ionInput)="searchBydatatype($event)"
      placeholder="{{ placeholderText }}"
      [ngStyle]="{
        'padding-right': canShowFilter && (showAdd || showDownload) ? '84px' : canShowFilter || showAdd || showDownload ? '50px' : '',
      }"
      [attr.data-testid]="pageSearch ? pageSearch + '-search-input' : 'admin-search-input'"
    ></ion-searchbar>

    @if (canShowFilter || showAdd || showDownload) {
      <ion-buttons mode="ios" class="admin-search-actions">
        @if (canShowFilter) {
          <ion-button
            mode="ios"
            fill="clear"
            class="admin-search-action"
            (click)="openFilterModal()"
            [attr.data-testid]="pageSearch ? pageSearch + '-filter-button' : 'admin-filter-button'"
          >
            <ion-icon name="options"></ion-icon>
          </ion-button>
        }
        @if (showAdd) {
          <ion-button
            mode="ios"
            fill="clear"
            class="admin-search-action"
            (click)="onAddClick()"
            [attr.data-testid]="pageSearch ? pageSearch + '-add-button' : 'admin-add-button'"
          >
            <ion-icon name="add"></ion-icon>
          </ion-button>
        }
        @if (showDownload) {
          <ion-button
            mode="ios"
            fill="clear"
            class="admin-search-action"
            (click)="onDownloadClick()"
            [disabled]="headerDownloadDisabled"
            [attr.aria-label]="headerDownloadExporting ? 'Exporting CSV' : 'Export CSV'"
            [attr.aria-busy]="headerDownloadExporting"
            title="Export CSV"
            [attr.data-testid]="pageSearch ? pageSearch + '-download-button' : 'admin-download-button'"
          >
            <ion-icon name="download"></ion-icon>
          </ion-button>
        }
      </ion-buttons>
    }
  </div>
</div>
